import React, { FC } from 'react';
import { Button } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import ColoredTooltip from '@/components/Common/ColoredTooltip';
import styles from './OTPAuthPhoneBox.module.scss';

interface OTPAuthPhoneBoxProps {
    phoneNumber: string;
    onSendCode: () => void;
    onSendVoiceCode?: () => void;
    isLoading?: boolean;
}

const OTPAuthPhoneBox: FC<OTPAuthPhoneBoxProps> = observer(({
    phoneNumber,
    onSendCode,
    onSendVoiceCode,
    isLoading,
}) => {
    const { t } = useTranslation();
    const nameSpace = 'recipientPage';

    return (
        <div className={styles.phoneBoxContainer} data-testid="recipientPage_auth_phoneBoxContainer">
            <h2 className={styles.title} data-testid="recipientPage_auth_phoneTitle">
                {t(`${nameSpace}.OTPSteps.checkPhone`)}
            </h2>
            <div className={styles.description} data-testid="recipientPage_auth_phoneDescription">
                {t(`${nameSpace}.OTPSteps.willSendCodeTo`)}
                {' '}
                <strong className={styles.phoneNumber}>{phoneNumber}</strong>
                <ColoredTooltip title={t(`${nameSpace}.OTPSteps.tooltip`)} placement="topLeft">
                    <InfoCircleOutlined className={styles.infoIcon} />
                </ColoredTooltip>
            </div>
            <Button
                type="primary"
                className={styles.sendButton}
                onClick={onSendCode}
                loading={isLoading}
                data-testid="recipientPage_auth_phoneSendCodeButton"
            >
                {t(`${nameSpace}.OTPSteps.sendCode`)}
            </Button>
            {onSendVoiceCode && (
                <div className={styles.voiceCallWrapper}>
                    <span className={styles.voiceText}>
                        {t(`${nameSpace}.OTPSteps.preferVoice`)}
                    </span>
                    <button
                        className={styles.voiceButton}
                        onClick={onSendVoiceCode}
                        disabled={isLoading}
                    >
                        {t(`${nameSpace}.OTPSteps.sendVoiceCode`)}
                    </button>
                </div>
            )}
        </div>
    );
});

export default OTPAuthPhoneBox;
